import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MagnifyingGlass, Shield } from '@phosphor-icons/react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import Footer from '../components/Footer';

const OrderLookupPage = () => {
  const [orderId, setOrderId] = useState('');
  const navigate = useNavigate();

  const go = (e) => {
    e.preventDefault();
    const id = orderId.trim();
    if (!id) return;
    navigate(`/order/${encodeURIComponent(id)}`);
  };

  return (
    <div className="min-h-screen bg-[#05050A] text-white">
      <header className="border-b border-white/10 px-4 py-3">
        <Link to="/" className="font-['JetBrains_Mono'] font-bold text-cyan-300">← ServerMemoryRFQ</Link>
      </header>
      <main className="max-w-xl mx-auto px-4 py-16">
        <div className="flex items-center gap-3 mb-3">
          <Shield size={28} weight="fill" className="text-cyan-300" />
          <h1 className="text-3xl font-['JetBrains_Mono'] font-bold">Track your order</h1>
        </div>
        <p className="text-[#94A3B8] text-sm mb-8">
          Enter the Order ID you received at checkout to view live escrow state, tracking, and open a dispute if needed.
        </p>
        <form onSubmit={go} className="space-y-3" data-testid="order-lookup-form">
          <label className="text-xs text-[#94A3B8] font-['JetBrains_Mono'] uppercase">Order ID</label>
          <Input
            value={orderId}
            onChange={(e) => setOrderId(e.target.value)}
            placeholder="e.g. 5f4e3d2c-1b0a-..."
            className="bg-[#11141D] border-[#334155] text-white font-mono"
            data-testid="order-lookup-input"
            autoFocus
          />
          <Button
            type="submit"
            disabled={!orderId.trim()}
            className="w-full bg-cyan-500 hover:bg-cyan-400 text-black font-['JetBrains_Mono']"
            data-testid="order-lookup-submit"
          >
            <MagnifyingGlass size={16} className="mr-2" weight="bold" /> View order
          </Button>
        </form>
        <div className="mt-10 bg-[#11141D] border border-[#1E293B] rounded-lg p-4 text-xs text-[#94A3B8] space-y-2">
          <p className="text-white font-['JetBrains_Mono'] text-sm">Don't have an Order ID?</p>
          <p>Every on-chain checkout returns an order ID immediately after you submit payment. Check your wallet history or the confirmation screen from <Link to="/agents" className="text-cyan-300 hover:text-white underline">/agents</Link>.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default OrderLookupPage;
